import ProcessingEmployeeResumes from "../../../../src/pages/use-cases/page-content/content-publishing/processing-employee-resumes.md";
import * as React from 'react';
export default {
  ProcessingEmployeeResumes,
  React
};